// Which features this instance offers, as the browser knows them.
//
// The server decides (backend/config/featureFlags.js) and sends the answer
// with every sign-in and every getProfile; App.js keeps it in localStorage
// under "features". This is the one place that reads it back, so Home, the
// navbar, the routes and the account menu can never disagree about what is on.
//
// The defaults here mirror the server's, for the moment before the first
// profile lands and for a browser holding an older copy. FlowOS is off unless
// this instance says otherwise (product owner, 28 Sep 2026) - so an absent or
// stale entry must never be read as "on".
export const FEATURE_DEFAULTS = Object.freeze({
  businessFlows: true,
  relationshipExplorer: true,
  advanceSearch: true,
  flowos: false,
});

export const FEATURE_KEYS = Object.keys(FEATURE_DEFAULTS);

// What the server last said, filled in with the defaults. Never throws: a
// browser with unreadable storage gets the defaults, not a blank app.
export function readFeatures(storage = typeof localStorage === "undefined" ? null : localStorage) {
  let stored = {};
  try {
    stored = JSON.parse(storage?.getItem("features") || "{}") || {};
  } catch (err) {
    stored = {};
  }
  return Object.fromEntries(
    FEATURE_KEYS.map((key) => [key, typeof stored[key] === "boolean" ? stored[key] : FEATURE_DEFAULTS[key]])
  );
}

// One feature, for a caller that only cares about one.
export const featureOn = (key) => Boolean(readFeatures()[key]);

export default readFeatures;
